import { render } from "./TableComponent.vue?vue&type=template&id=e0dd2fc8&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=e0dd2fc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0dd2fc8"]])

export default __exports__